import Vue from 'vue';
import Router from 'vue-router';
import Resource from 'vue-resource';
import { createSandbox } from 'vue-kindergarten';
import child from '@/child';
import store from '@/store';
import Login from '@/components/Login';
import ConfirmEmail from '@/components/ConfirmEmail';
import PasswordCreation from '@/components/PasswordCreation';
import Logout from '@/components/Logout';
import Complaints from '@/components/complaints/Complaints';
import ComplaintsEcommerce from '@/components/complaints/ComplaintsEcommerce';
import New from '@/components/complaints/New';
import NewPreApproved from '@/components/complaints/NewPreApproved';
import ShowComplaint from '@/components/complaints/ShowComplaint';
import ShowComplaintEcommerce from '@/components/complaints/ShowComplaintEcommerce';
import Operators from '@/components/Operators';
import Status from '@/components/complaints/Status';
import Finance from '@/components/Finance';
import Users from '@/components/Users';
import All from '@/components/complaints/All';
import constants from '@/constants/Url.constants';
import * as fn from '@/utils/functions';
import * as perimeters from '@/perimeters';
import Categories from '../components/Categories';

Vue.use(Router);
Vue.use(Resource);

Vue.http.options.root = constants.API_URL;

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/complaints',
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/operators',
      name: 'operators',
      component: Operators,
      meta: { auth: true },
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: { auth: true },
    },
    {
      path: '/categories',
      name: 'categories',
      component: Categories,
      meta: { auth: true },
    },
    {
      path: '/finance',
      name: 'finance',
      component: Finance,
      meta: { auth: true },
    },
    {
      path: '/complaints',
      name: 'complaints',
      component: Complaints,
      meta: { auth: true },
    },
    {
      path: '/complaints_ecommerce',
      name: 'complaints_ecommerce',
      component: ComplaintsEcommerce,
      meta: { auth: true },
    },
    {
      path: '/complaints/new',
      name: 'new',
      component: New,
      meta: { auth: true },
    },
    {
      path: '/complaints/all',
      name: 'all',
      component: All,
      meta: { auth: true },
    },
    {
      path: '/complaints/pre-approved',
      name: 'new_pre_approved',
      component: NewPreApproved,
      meta: { auth: true },
    },
    {
      path: '/complaints_ecommerce/:complaint_id',
      name: 'show_complaint_ecommerce',
      component: ShowComplaintEcommerce,
      meta: { auth: true },
    },
    {
      path: '/complaints/:complaint_id',
      name: 'show_complaint',
      component: ShowComplaint,
      meta: { auth: true },
    },
    {
      path: '/status/:complaint_id',
      name: 'status',
      component: Status,
      meta: { auth: false },
    },
    {
      path: '/confirm_email',
      name: 'confirm_email',
      component: ConfirmEmail,
      meta: { auth: false },
    },
    {
      path: '/password_creation',
      name: 'password_creation',
      component: PasswordCreation,
      meta: { auth: false },
    },
    {
      path: '*',
      redirect: '/complaints',
    },
  ],
});

router.beforeEach((to, from, next) => {
  fn.changeTitle(to, from, next);
  if (to.meta.auth) {
    const validSession = !!localStorage.getItem('token') &&
      ((Math.round(new Date().getTime() / 1000)) < store.state.expiration);
    const role = store.state.user.role;
    if (validSession && role !== undefined) {
      const perimeter = perimeters[`${to.name}Perimeter`];
      if (perimeter) {
        const sandbox = createSandbox(child(store), {
          perimeters: [
            perimeter,
          ],
        });
        if (!sandbox.isAllowed('route')) {
          next('/');
        }
      }
      next();
    } else {
      next({ path: '/login' });
    }
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js